import { KycIcon } from "../../../components/icons/status";
import { Flex } from "../../../components/layout";
import { Loader } from "../../../components/loader";
import { useFetchable } from "../../../store/common/fetchable";
import { Users } from "../../../store/users/reducer";
import { ProfileRoutes } from "../../profile/routes";
import { KycStatusWidget } from ".././tiles/common";

export const KycStatusTile = () => {
  const currentUserFetchable = useFetchable(Users.current);
  return (
    <Loader data={[currentUserFetchable]}>
      {([current]) =>
        current.kycStatus ? (
          <KycStatusWidget
            title="My KYC Status:"
            center
            to={ProfileRoutes.name}
          >
            <Flex center>{KycIcon(current.kycStatus, "kyc", true)}</Flex>
          </KycStatusWidget>
        ) : null
      }
    </Loader>
  );
};
